import { getGclid } from '@src/functions/gclid'
import { withAttribution } from '@src/functions/attribution'
import openKustomer from '@src/functions/kustomer'
import classes from '@src/styles/PitchLeft.module.css'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import querystring from 'query-string'

const HeroText = () => (
  <h3 className={classes.heroText}>
    Sustainable
    <br /> Solutions for
    <br /> a Brighter Future
  </h3>
)

const SubText = () => {
  const history = useRouter()
  const { keyword, location } = history.query
  const handleBook = () => {
    history.push(
      withAttribution(
        `${process.env.NEXT_PUBLIC_REDIRECT_URL}booking?`.concat(
          querystring.stringify({
            business_client: 1,
            redirect: 0,
            gclid: getGclid(),
            keyword: keyword ?? "",
            location: location ?? "",
          }),
        ),
      ),
    )
  }

  return (
    <>
      <p className={classes.subText}>
        Dimension empowers you with the tools and tech you need to ensure that your waste management
        is as good for the environment as it is for your business.
      </p>
      <div className={classes.buttonContainer}>
        <button
          className={classes.primaryButton}
          onClick={handleBook}
        >
          Book Now
        </button>
        <button className={classes.secondaryButtonDark} onClick={openKustomer}>
          <span>Chat With Us</span>
        </button>
      </div>
    </>
  )
}

function Pitch() {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classNames(classes.leftPane, classes.highLeft)}>
          <div className={classes.pitchContent}>
            <HeroText />
            <SubText />
            {/* <TrustBox style="landing-widget" /> */}
          </div>
        </div>
        <div className={classNames(classes.rightPane, classes.sustainability)} />
      </div>
    </div>
  )
}
export default Pitch
